import {
  FormControl,
  FormField,
  FormLabel,
} from "@acdc2/ui/components/access-form";
import { Input } from "@acdc2/ui/components/input";
import { useTranslation } from "react-i18next";
import { ValueMissingFormMessage } from "../../ui/forms";

type Props = React.ComponentProps<typeof Input>;

export function TableCellRowSpanFormField(props: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="tableCellRowSpan">
      <FormLabel>{t("TableCellRowSpanFormField.label")}</FormLabel>
      <FormControl asChild>
        <Input
          placeholder={t("TableCellRowSpanFormField.placeholder")}
          type="number"
          inputMode="numeric"
          min={1}
          required
          {...props}
        />
      </FormControl>
      <ValueMissingFormMessage />
    </FormField>
  );
}
